<template>
  <div class="serch_border">
    <div class="serchform">
      投资领域：
      <a-tag :class="{'tag-active':''==investmentFields}"  @click="postSerchData({'investmentField':''})">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==investmentFields}"  @click="postSerchData({'investmentField':item.dictValue})" v-for="(item,key) in options.investmentField" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div>
  <div class="serch_border">
    <div class="serchform">
      投资阶段：
      <a-tag :class="{'tag-active':''==projectStages}"  @click="postSerchData({'projectStage':''})">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==projectStages}"  @click="postSerchData({'projectStage':item.dictValue})" v-for="(item,key) in options.projectStage" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div>
  <div class="cont_body">
    <div v-for="(item,key) in optionsData" :key="key" class="list_cont flex-cl" @click="goMore('/finance/project/page','sy',item.id)">
      <div class="img">
        <img :src="getImg(item.picture)" alt="">
      </div>
      <h3>{{item.projectName}}</h3>
      <p class="text">{{item.projectOverview}}</p>
      <p class="tag"><dict-render :dict-obj="dictObjs['investmentField']"
        :text="item.projectField"></dict-render></p>
    </div>
  </div>
  <a-pagination style="clear:both;float:right" v-model:current="current" :total="10" show-less-items />
</template>
<script>
import { dictMixin } from "@/mixins";
import {financeProjectWeb} from "@/api/finance";
import {common_controller} from "@/api/commonService";
import {file_service} from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
import {financeDict} from "@/config/variableConfig"
export default {
  name: 'investor',
  components: { DictRender },
  mixins: [dictMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 查询条件
      investmentFields: '',// 投资领域
      projectStages: '', //投资阶段
      dictNames: 'investmentField,position,invest_limit,projectStage',
      optionsData:null,
      financeDict,
      options:null,
    }
  },
  mounted() {
      this.getDict();
      this.getSerchData();
  },
	methods: {
    postSerchData(val){
      if(val){
          if(val.investmentField||val.investmentField==''){
            this.investmentFields = val.investmentField
          }
          if(val.projectStage||val.projectStage==''){
            this.projectStages = val.projectStage
          }
      }
      this.getSerchData()
      
    },
    getSerchData(){
      this.getAction({
            url: financeProjectWeb.pageList,
            params: {
              pageNum: 1,
              pageSize: 10,
              projectField: this.investmentFields,
              projectStage: this.projectStages
            },  
        }).then(res => {
          this.optionsData = res.records
        })
    },
    getDict(){
        this.getAction({
            url:common_controller.getDictDataByGroupNumber,
            params: {
                groupNumbers: "investmentField,projectStage"
            }
        }).then(res=>{
            this.options = res
        })
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url,key,id) {
			this.$router.push({path: url, query: {type: key,queryData: id}})
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
.list_cont{
  width: 288px;
  margin-right:16px;
  margin-bottom:16px;
  padding: 25px 15px;
  &:nth-child(4n){
    margin-right: 0;
  }
  .img{
    border:1px solid #eeeeee;
    width: 100px;
    height:100px;
    display: flex;
    align-items: center;
    img{
      width: 100%;
    }
  }
  h3{
    font-size: 20px;
    line-height: 60px;
  }
  p{
    font-size: 16px;
  }
  .text{
    width:100%;
    height: 75px;
    text-align: left;
    word-break: break-all;
    overflow:hidden; 
    text-overflow:ellipsis; 
    display:-webkit-box;
    -webkit-box-orient:vertical;  
    -webkit-line-clamp:3;
  }
  .tag{
    text-align: left;
    margin-top: 25px;
    width: 100%;
    color:#cccccc;
  }

}
</style>